import React, { useState, useEffect } from 'react';
import Tabs from '../../Components/Tabs';
import LeaveRequestsListScreen from '../View/LeaveRequestsListScreen';
import LeaveApprovalsListScreen from '../View/LeaveApprovalsListScreen';
import LeaveManagementController from "../Controllers/LeaveManagementController";

const LeaveManagementScreen = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [disabledTabs, setDisabledTabs] = useState([]);

    const {
        leaveRequestsList, leaveRequestsLoading, leaveRequestsError,
        leaveApprovalList, leaveApprovalLoading, leaveApprovalError,
        leaveRequestRefresh, leaveApprovalRefresh
    } = LeaveManagementController();

    useEffect(() => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_') || '{}');
        const { per_name_sub_json } = storedUserInfo?.user_permissions?.leave_mgmt || {};

        const requestTabDisabled = per_name_sub_json?.leave_req === 0;
        const approvalTabDisabled = per_name_sub_json?.approve_leave === 0;

        const disabledTabIndices = [];
        if (requestTabDisabled) disabledTabIndices.push(0);
        if (approvalTabDisabled) disabledTabIndices.push(1);

        setDisabledTabs(disabledTabIndices);

        if (disabledTabIndices.includes(selectedTab)) {
            const firstEnabledTab = [0, 1].find(tab => !disabledTabIndices.includes(tab));
            setSelectedTab(firstEnabledTab ?? 0);
        }
    }, [selectedTab]);

    const handleTabChange = (index) => {
        if (!disabledTabs.includes(index)) {
            setSelectedTab(index);
        }
    };

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{ paddingBottom: 20 }}>
                <h2 className='title'>Leave Management</h2>
            </div>

            <div>
                <Tabs
                    tabs={['Leave Requests', 'Approvals']}
                    selectedIndex={selectedTab}
                    onTabChange={handleTabChange}
                    disabledTabs={disabledTabs}
                >
                    {selectedTab === 0 && !disabledTabs.includes(0) &&<LeaveRequestsListScreen leaveRequestsList={leaveRequestsList} loading={leaveRequestsLoading} error={leaveRequestsError} onRefresh={leaveRequestRefresh} />}
                    {selectedTab === 1 && !disabledTabs.includes(1) &&<LeaveApprovalsListScreen leaveApprovalList={leaveApprovalList} loading={leaveApprovalLoading} error={leaveApprovalError} onRefresh={leaveApprovalRefresh} />}
                    {/* {selectedTab === 0 && !disabledTabs.includes(0) && <LeaveRequestsListScreen />}
                {selectedTab === 1 && !disabledTabs.includes(1) && <LeaveApprovalsListScreen />} */}
                </Tabs>
            </div>
        </div>
    );
};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto',
    }
};

export default LeaveManagementScreen;

